module.exports = __webpack_public_path__ + "img/face.45833067.png";